import { useCallback, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useInView } from 'react-intersection-observer'
import { useSellers } from '../../../../app/hooks/useSellers'

export const useTeamsMembersPageController = () => {
  const { id } = useParams()
  const { ref, inView } = useInView()
  const navigate = useNavigate()

  const handleSellerDetailsPage = (id: string) => {
    navigate(`/vendedores/${id}`)
  }

  const {
    data,
    isFetching,
    isLoading,
    setParams,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useSellers({ initialLimit: 30 })

  const setTeamId = useCallback(() => {
    if (id) {
      setParams((state) => ({ ...state, teamIds: id }))
    }
  }, [id, setParams])

  useEffect(() => {
    setTeamId()
  }, [setTeamId])

  useEffect(() => {
    if (inView) {
      fetchNextPage()
    }
  }, [fetchNextPage, inView])

  return {
    handleSellerDetailsPage,
    data,
    isFetching,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    ref,
  }
}
